import { render, staticRenderFns } from "./PendapatanSection.vue?vue&type=template&id=23098251&scoped=true"
import script from "./PendapatanSection.vue?vue&type=script&lang=js"
export * from "./PendapatanSection.vue?vue&type=script&lang=js"
import style0 from "./PendapatanSection.vue?vue&type=style&index=0&id=23098251&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23098251",
  null
  
)

export default component.exports